import type { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { FormField, Textarea } from '@/shared/components';
import { DESCRIPTION_MAX_LENGTH, type ResourceValues } from './resourceModel';

/**
 * Kurzbeschreibung für Gäste in Deutsch und Englisch. Englisch darf leer bleiben — das Portal zeigt
 * dann die deutsche (wie bei Hausordnung und Apartmentbeschreibung).
 */
export function ResourceDescriptionFields({
  register,
  watch,
  errors,
}: {
  register: UseFormRegister<ResourceValues>;
  watch: UseFormWatch<ResourceValues>;
  errors: { descriptionDe?: string; descriptionEn?: string };
}) {
  const length = (value: string | undefined) => `${value?.length ?? 0}/${DESCRIPTION_MAX_LENGTH}`;
  return (
    <div className="space-y-3">
      <FormField
        label="Beschreibung für Gäste (Deutsch)"
        hint={length(watch('descriptionDe'))}
        error={errors.descriptionDe}
      >
        <Textarea
          {...register('descriptionDe')}
          rows={3}
          maxLength={DESCRIPTION_MAX_LENGTH}
          placeholder="z. B. Finnische Sauna mit Ruheraum, Handtücher liegen bereit."
        />
      </FormField>
      <FormField
        label="Beschreibung für Gäste (Englisch)"
        hint={`${length(watch('descriptionEn'))} · leer: Gäste sehen die deutsche`}
        error={errors.descriptionEn}
      >
        <Textarea {...register('descriptionEn')} rows={3} maxLength={DESCRIPTION_MAX_LENGTH} />
      </FormField>
    </div>
  );
}
